module.exports = __webpack_public_path__ + "assets/img/29_283_big.4243e234.jpg";